export default "__VITE_ASSET__D_V4FOXw__"